import { TaskScreens } from "./tasks";

export const TasksNavigation=function(props:{changeScreen:Function}){
	return(
		<div id='teachers-tasks-navigation'>
			<button className='teachers-button teachers-button-default' onClick={()=>{props.changeScreen(TaskScreens.Create);}}>Create Task</button>
			<button className='teachers-button teachers-button-default' onClick={()=>{props.changeScreen(TaskScreens.View)}}>View Tasks</button>
		</div>
	);
}
